import { type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { UserType } from '@avanta/shared/constants/users';
import { type Patient } from '@avanta/shared/types/patients';
import { type User } from '@avanta/shared/types/users';
import { getUserId } from '@avanta/shared/utils/storage';
import { service } from '../api';
import { logout } from '../auth';

const PATIENTS_URL = `${BASE_URL}patients`;

export type PatientServiceTypes = {
  getPatient: (patientId?: string) => Promise<AxiosResponse<User>>;
  updatePatient: (patient: Patient) => Promise<void>;
  deletePatient: (userId: string, redirect?: boolean) => Promise<void>;
};

export const PatientService: PatientServiceTypes = {
  getPatient: async (patientId = getUserId()) => service.get(`${PATIENTS_URL}/${patientId}`),
  updatePatient: async patient =>
    service.put(`${PATIENTS_URL}/${patient.id}`, { ...patient, type: UserType.PATIENT }),
  deletePatient: async (userId = getUserId(), redirect = true) => {
    await service.delete(`${PATIENTS_URL}/${userId}`);
    if (redirect) {
      logout();
    }
  },
};
